<template>
	<div class="main">
		<div class="naverwebtoon">
			<img class="close b-close" src="../assets/image/close.png" alt="">
			<a href=""><img src="../assets/image/naverwebtoon_bigbanner.png" alt=""></a>
		</div>
		<div class="box">
			<Header></Header>
			<img class="loading" :src="gameData.topBgImage" alt="">
			<div class="item_welfare">
				<div class="content">
					<UserInfo ref="userInfo"></UserInfo>
					<div class="describe">
						<img src="../assets/image/push.png" alt="">
						<span>|</span>
						<p class="marquee"><span>{{ horseRaceLamp }}</span></p>
					</div>
					<div class="position">
						<div class="countdown">
							<img src="../assets/image/alarm1.png" alt="">
							<div class="time">
								<p>{{ countdown.d }}</p>
								<span>d</span>
								<p>{{ countdown.h }}</p>
								<span>h</span>
								<p>{{ countdown.m }}</p>
								<span>m</span>
								<p>{{ countdown.s }}</p>
								<span>s</span>
							</div>
						</div>
						<ul>
							<li v-for="(item, index) in welfareList"
								:class="!stateList[item.level].buttonDisplay && rewardMode == 1 ? 'disable' : ''">
								<img class="first" :src="item.icon" alt="">
								<div class="welfare_right">
									<p>{{ item.title }} <span>({{ item.condition }})</span></p>
									<p class="prop " v-html="cutout(item.describe)"></p>
									<div class="progress-container" v-if="item.amount > 0">
										<div class="percentage">{{ stateList[item.level].giftResidueRate }}%</div>
										<div class="progress-bar"
											:style="'width:' + stateList[item.level].giftResidueRate + '%'"></div>
									</div>
									<button v-if="!item.isDisable" v-on:click="receive(item.level)"
										v-show="stateList[item.level].buttonDisplay"
										:class="['receive', stateList[item.level].buttonDisabled == false ? 'bg_color' : '']"
										:disabled="stateList[item.level].buttonDisabled">{{ $t('claim_text') }}</button>
									<button v-if="item.isDisable" class="receive">{{ $t('contact_customer_service_text')
									}}</button>
									<div v-if="!stateList[item.level].buttonDisplay && rewardMode == 0">
										<div class="package">
											<p>{{ gfitCodeOverlengthOmit(stateList[item.level].giftCode) }}</p>&nbsp;<i
												class="fa fa-clipboard color" v-clipboard:success="onCopySuccess"
												v-clipboard:copy="stateList[item.level].giftCode"></i>
										</div>
									</div>
									<button v-if="!stateList[item.level].buttonDisplay && rewardMode == 1"
										class="receive">{{
											$t('claimed_text') }}</button>
								</div>
							</li>
						</ul>
						<p class="h3">{{ $t('instructions_text') }}:</p>
						<p class="instructions">[{{ gameData.gameName }}]
							official website offers extra top-up rebates. Participate in relevant events on the official
							website and you will be able to obtain valued gift packages during the event time. When you
							reach the requirement, you can claim the Gift Code on the official website and redeem it in
							the game. The Gift Code can only be used once. We do not suggesting giving or exposing the
							Gift Code to others.
						</p>
						<!-- <a class="color" :href="gameData.apkLink">[Ancient Seal: The Exorcist] Official Facebook
							>></a><br>
						<a class="color" :href="gameData.facebookFanPage">[Ancient Seal: The Exorcist] Official APK
							Download >></a><br> -->
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
		<TipsWindow ref="tips"></TipsWindow>
	</div>
</template>

<script>
import $ from 'jquery'
import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
import UserInfo from '../components/userInfo.vue'
import TipsWindow from '../components/tipsWindow.vue'
import axios from 'axios'
import {
	isEmpty,
	isNotEmpty
} from '../utils/index.js'
import {
	getWelfareJsonUrl
} from '../utils/api'
export default {
	name: 'welfare',
	components: {
		Header,
		Footer,
		UserInfo,
		TipsWindow
	},
	data() {
		return {
			rewardMode: 0,
			horseRaceLamp: '',
			activityCode: '',
			startTime: 0,
			endTime: 0,
			welfareList: [],
			stateList: {},
			countdown: { d: 0, h: 0, m: 0, s: 0 },
			gameData: this.$store.state.gameData
		}
	},
	mounted() {
		this.loadWelfareList();
		this.changeBackground(this.gameData.bottomBgImage);
	},
	methods: {
		cutout(cellValue) {
			return cellValue.replace(/\,/g, '</br>')
		},
		gfitCodeOverlengthOmit: function (giftCode) {
			return giftCode.length > 12 ? (giftCode.substr(0, 12) + "...") : giftCode;
		},
		loadWelfareList: function () {
			axios.get('/static/json/welfare/limit/' + this.gameData.gameCode + '.json?v' + (new Date()).getTime())
				.then((response) => {
					this.horseRaceLamp = response.data.horseRaceLamp;
					this.rewardMode = response.data.rewardMode;
					this.activityCode = response.data.actCode;
					this.startTime = response.data.startTime;
					this.endTime = response.data.endTime;
					let _this = this;
					// let currTime = new Date().getTime();
					response.data.welfareList.forEach(function (obj, index) {
						// 活动长期有效，不加入起止时间判断
						// if ((_this.startTime < currTime && _this.endTime > currTime) || obj.amount == 0) {
						_this.welfareList.push(obj);
						_this.$set(_this.stateList, obj.level, {
							buttonDisabled: true,
							buttonDisplay: true,
							giftCode: '',
							amount: obj.amount,
							giftResidueRate: 0
						})
						// }
					})
					this.initaccumulateTopupActivityData();
				});
		},
		initaccumulateTopupActivityData: function () {
			if (this.$session.hasLogin()) {
				this.$axios({
					method: 'get',
					url: '/web/api/gift/initAccumulateTopupActivityData',
					params: {
						actCode: this.activityCode,
						userId: this.$session.getUserId(),
						gameCode: this.$cache.getGameCode(),
					}
				})
					.then(response => {
						if (response.code === 1000) {
							let data = response.data;
							this.startActvityCountdown(data.actEndTime);
							if (isNotEmpty(data.meetLevel)) {
								let _this = this;
								data.meetLevel.split(",").forEach(function (level) {
									if (isNotEmpty(level) && isNotEmpty(_this.stateList[level])) {
										_this.stateList[level].buttonDisabled = false;
									}
								});
							}
							if (isNotEmpty(data.rewardList)) {
								for (let attr in data.rewardList) {
									if (isNotEmpty(this.stateList[attr])) {
										this.stateList[attr].giftCode = data.rewardList[attr];
										this.stateList[attr].buttonDisplay = false;
									}
								}
							}
							if (isNotEmpty(data.amount)) {
								let _this = this;
								this.welfareList.forEach(function (obj, index) {
									let conditionAmount = _this.stateList[obj.level].amount;
									if (data.amount >= conditionAmount) {
										_this.stateList[obj.level].giftResidueRate = 100;
									} else {
										_this.stateList[obj.level].giftResidueRate = Math.floor((data
											.amount /
											conditionAmount) * 100);
									}
								})

							}
						}
					})
			}
		},
		startActvityCountdown: function (endTime) {
			let _this = this;
			function updateCountdown() {
				const now = new Date().getTime();
				const distance = endTime - now;
				if (distance < 0) {
					clearInterval(timer);
					_this.countdown.d = 0;
					_this.countdown.h = 0;
					_this.countdown.m = 0;
					_this.countdown.s = 0;
					return;
				}
				_this.countdown.d = Math.floor(distance / (1000 * 60 * 60 * 24));
				_this.countdown.h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				_this.countdown.m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
				_this.countdown.s = Math.floor((distance % (1000 * 60)) / 1000);
			}
			const timer = setInterval(updateCountdown, 1000);
			updateCountdown();
		},
		receive: function (level) {
			let _role = this.$cache.getRoleInfo();
			if (isEmpty(_role)) {
				this.$refs.userInfo.openRoleChooseWindow();
				return;
			}
			this.$axios({
				method: 'get',
				url: '/web/api/gift/receive',
				params: {
					actCode: this.activityCode,
					userId: this.$session.getUserId(),
					gameCode: this.$cache.getGameCode(),
					serverCode: _role.serverCode,
					roleId: _role.roleId,
					level: level
				}
			})
				.then(response => {
					if (response.code === 1000) {
						this.stateList[level].giftCode = response.data;
						this.stateList[level].buttonDisplay = false;
						if (this.rewardMode == 1) {
							this.$refs.tips.show(this.$i18n.tc('receive_reward_tips_text'));
						}
					} else {
						this.$refs.tips.show(response.message);
					}
				})
		},
		onCopySuccess(e) {
			this.$refs.tips.show(this.$i18n.tc('copy_successful_text'));
		},
		changeBackground(newPath) {
			
		}
	}
}
</script>

<style></style>